
export default {
  ADD_PARTNERS (state, partners) {
    state.partners = partners
  },
  ADD_NEW_PARTNER (state, partner) {
    state.partners.push(partner)
  },
  ADD_PARTNER (state, partner) {
    state.partner = partner
  },
  DELETE_PARTNER (state, id) {
    state.partners = state.partners.filter(p => p.id !== id)
  },
  UPDATE_PARTNER (state, partner) {
    Object.assign(state.partners.find(p => p.id === partner.id), partner)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/partners.js